import { Tags } from "lucide-react";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { ModifyOrderTagsActionNodeEditor } from "./editor";
import { ModifyOrderTagsActionNodePanel } from "./panel";

const newNodeDefaultConfig: any = {
  add: [],
  remove: [],
};

const newNodeDefaultValue: any = {
  actionType: "modify_order_tags",
  config: newNodeDefaultConfig,
};

export default registerNode<any["data"]>({
  type: "action:modify_order_tags",
  name: "workflowsEditor.nodes.modifyOrderTags.title",
  description: "workflowsEditor.nodes.modifyOrderTags.description",
  Icon: Tags,
  category: NodeCategory.ACTION,
  color: "blue",
  editor: {
    component: ModifyOrderTagsActionNodeEditor,
  },
  configPanel: {
    component: ModifyOrderTagsActionNodePanel,
  },
  newNodeDefaultData: newNodeDefaultValue,
});

export { ModifyOrderTagsActionNodeEditor } from "./editor";
export { ModifyOrderTagsActionNodePanel } from "./panel";
